import request from './index'

// 员工端菜单显示配置
export function getEmployeeMenus() {
  return request({ url: '/employee-menus', method: 'get' })
}

export function updateEmployeeMenus(data) {
  return request({ url: '/employee-menus', method: 'put', data })
}

// 模块级缓存：路由守卫与布局共用，避免同一会话重复请求
let employeeMenusCache = null

export async function getEmployeeMenusCached() {
  if (employeeMenusCache) return employeeMenusCache
  const res = await getEmployeeMenus()
  employeeMenusCache = (res.data && res.data.menus) || []
  return employeeMenusCache
}

export function invalidateEmployeeMenusCache() {
  employeeMenusCache = null
}

// 工作时长设置
export function getWorkTimeSettings() {
  return request({ url: '/system/work_time_settings', method: 'get' })
}

export function updateWorkTimeSettings(data) {
  return request({ url: '/system/work_time_settings', method: 'put', data })
}
